<template>
  <div class="dashboard" >
    <v-layout row wrap class="my-5 px-1">
      <v-flex xs12>
        <v-layout wrap row justify-start class="mb-3">
          <v-flex xs6  pa-1>
            <v-text-field
              label="Search By Code"
              hide-details
              solo
              v-model="searchText"
              @input="filterMoveOrders()"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-autocomplete
              name="Source Warehouse"
              label="Source Warehouse"
              solo :loading="loading"
              hide-details
              item-text="name"
              clearable
              @change="filterMoveOrders()"
              :items="warehouses"
              v-model.trim="warehouse"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-autocomplete
              name="SKU"
              label="SKU"
              solo :loading="loading"
              @change="filterMoveOrders()"
              :items="products"
              item-text="sku"
              clearable
              item-value="sku"
              hide-details
              v-model.trim="product"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-menu
              v-model="cDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="fcreate_date"
                  label="From Date"
                  append-icon="event"
                  @change="filterMoveOrders()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="fcreate_date" @change="filterMoveOrders()" @input="cDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-menu
              v-model="tcDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="tcreate_date"
                  label="To Date"
                  append-icon="event"
                  @change="filterMoveOrders()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="tcreate_date" @change="filterMoveOrders()" @input="tcDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 px-1>
            <v-btn color="primary" block large @click="exportPos()">export</v-btn>
          </v-flex>
          <v-flex xs2 px-1>
            <v-btn color="primary" block large @click="goTo(`/move`)">new</v-btn>
          </v-flex>
        </v-layout>
        <div v-if="loading" class="text-xs-center">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </div>
        <v-layout row wrap py-3>
          <v-flex xs12 sm12 md12>
            <v-switch label="Table View" v-model="table"></v-switch>
          </v-flex>
          <v-flex xs12 sm12 md12  v-if="!table">
              <span> {{ filteredMoveOrders.length}} Results </span>
              <div class="text-xs-center">
                <v-pagination
                  v-model="currentPage"
                  :length="pagesNumber"
                  :total-visible="5"
                  @input="updateVisible"
                ></v-pagination>
              </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="table" class="tableDiv">
          <v-flex xs12>
            <v-data-table
              :headers="TableHeaders"
              :items="TableData"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td v-for="(h, i) in TableHeaders" :key="'-val-' + i">
                  <span
                    v-if="h.value != 'key'"
                    v-clipboard:copy="props.item[h.value]"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  > {{ props.item[h.value] }} 
                    <!-- <v-icon size="14" @click="goTo(`/purchase/${props.item.key}`)">open_in_new</v-icon> -->
                  </span>
                  <span
                    v-if="h.value == 'key'"
                    style="cursor:pointer;color:#2196f3;"
                    @click="goTo(`/move/${props.item['key']}`)"
                  > {{ props.item[h.value] }}<v-icon color="red" size="14">open_in_new</v-icon>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 sm12 md12 v-for="po in visibleMoveOrders" :key="po.key" mb-1>
            <v-card>
              <v-card-text>
                <v-layout row wrap align-center>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">KEY</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.key"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.key }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">Creator</div>
                    <div class="subheadline">{{ po.creator }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">CREATE DATE</div>
                    <div class="subheadline">{{ po.create_date }}</div>
                  </v-flex>
                  <v-flex xs6>
                    <div style="font-size:11px;font-weight:600;"> From WH</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.fwh"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.fwh }}</div>
                  </v-flex>
                  <v-flex xs6>
                    <div style="font-size:11px;font-weight:600;"> To WH</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.twh"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.twh }}</div>
                  </v-flex>
                  <v-flex xs12 pt-3>
                    <v-expansion-panel expand>
                      <v-expansion-panel-content>
                        <div slot="header">ITEMS</div>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-layout row wrap class="text-xs-left">
                                  <v-flex xs3>
                                    <div style="font-size:10px;font-weight:600;">SKU</div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div style="font-size:10px;font-weight:600;">QT.</div>
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    <div style="font-size:10px;font-weight:600;">PRICE</div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 v-for="(item, it) in po.items" py-1 :key="'item-'+it">
                                <v-layout row wrap class="text-xs-left">
                                  <v-flex xs3
                                    v-clipboard:copy="item.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{item.sku}}
                                  </v-flex>
                                  <v-flex xs3>
                                    {{item.quantity}}
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    {{item.price}}
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                  
                </v-layout>
              </v-card-text>
              <v-card-actions dense>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark small @click="goTo(`/move/${po.key}`)">Edit</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 sm12 md12>
            <div class="text-xs-center">
              <v-pagination
                v-model="currentPage"
                :length="pagesNumber"
                :total-visible="7"
                @input="updateVisible"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
import json2csv from 'json2csv'

export default {
  data() {
    return {
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      moveorders:[],
      filteredMoveOrders:[],
      visibleMoveOrders:[],
      vendors:[],
      warehouses:[],
      products:[],
      vendor:null,
      warehouse:null,
      product:null,
      status:null,
      fcreate_date:null,
      cDate:null,
      tcDate:null,
      tcreate_date:null,
      invoicers:[],
      invoice_by:null,
      table:true,
      TableHeaders:[],
      TableData:[],
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
		updateVisible() {
      this.sortByDate()
      this.visibleMoveOrders = this.filteredMoveOrders.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredMoveOrders = this.filteredMoveOrders.sort((a, b)=>a.timestamp - b.timestamp)
    },
    getPagesNumber(){
      if (this.filteredMoveOrders.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredMoveOrders.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredMoveOrders.length / this.pageSize) + 1
      }
		},
		filterMoveOrders() {
      this.loading = true
      console.log(this.moveorders)
			this.filteredMoveOrders = this.moveorders
      .filter(x=>{
        if(this.searchText){
          this.searchText = this.searchText.toLowerCase()
          for (const key in x) {
            if (Object.hasOwnProperty.call(x, key) && typeof x[key] == 'string') {
              if(x[key] && x[key].toLowerCase().includes(this.searchText)) {
                return x
              }
            }
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.warehouse) {
          if(x.fwh == this.warehouse || x.twh == this.warehouse) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.product && x.items) {
          if(x.items.map(x=>x.sku).includes(this.product)) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{ // create date
        if(!this.fcreate_date) return x
        if(!this.tcreate_date) return x
        let t = new Date(x.date).getTime()
        let z = new Date(this.fcreate_date).getTime()
        let y = new Date(this.tcreate_date).getTime()
        if (t >= z && t <= y) return x
      })
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
      this.loadTable()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async getMoveOrders(){
      this.loading = true
      let moveorders = await store.collection(`moveorders`).get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      console.log(moveorders)
      this.moveorders = moveorders
      this.filterMoveOrders()
    },
    async loadVendors(){
      this.loading = true
      let a = await db.ref('settings/vendors').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.vendors = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.vendor = {}
      this.loading = false
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      console.log(this.warehouses)
      this.loading = false
    },
    async loadProducts(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await db.ref(`productsCoreLite`)
        .once('value').then(x=>x.val())
        let b = Object.keys(a)
        let c = Object.values(a).map((x,i)=>{
          return {
            ...x, 
            key:b[i],
          }})
        this.products = c
        this.loading = false
        res(true)
      })
    },
    async LoadInvoices(){
      let a = await db.ref('settings/invoiceby').once('value').then(x=>x.val())
      if(a) {
        let b = Object.values(a).map(x=>x.name)
        this.invoicers = b
      }
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'po_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    exportPos() {
      let pos = this.filteredMoveOrders
      console.log(pos)
      let epo = [];
      for (let i = 0; i < pos.length; i++) {
        const po = pos[i];
        let ks = Object.keys(po).filter(x=> typeof po[x] == 'string')
        let dpo = {}
        ks.forEach(x=> dpo[x] = po[x])
        let post = po.status_timeline ? Object.values(po.status_timeline) : []
        let postst = {}
        post.forEach(x=>postst[x.status]=x.date)
        console.log(dpo)
        for (let h = 0; h < po.items.length; h++) {
          const item = po.items[h];
          let a = {
            ...dpo,
            ...item,
            item_name:this.products.filter(x=>x.sku == item.sku).length? this.products.filter(x => x.sku == item.sku)[0].item_name:'',

          }
          epo.push(a)
        }
      }
      this.exportData(epo)
    },
    loadTable() {
      this.loading = true
      let pos = this.filteredMoveOrders
      let epo = [];
      if(!pos.length) {
        this.loading = false
        this.TableData = epo
        return
      }
      for (let i = 0; i < pos.length; i++) {
        const po = pos[i];
        let ks = Object.keys(po).filter(x=> typeof po[x] == 'string')
        let dpo = {}
        ks.forEach(x=> dpo[x] = po[x])
      
        for (let h = 0; h < po.items.length; h++) {
          const item = po.items[h];
          let a = {
            ...dpo,
            ...item,
            item_name:this.products.filter(x=>x.sku == item.sku).length? this.products.filter(x => x.sku == item.sku)[0].item_name : '',

          }
          epo.push(a)
        }
      }
      this.TableHeaders = Object.keys(epo[0]).map(x=>{return {text:x.toUpperCase(), value:x}})
      this.TableData = epo
      this.loading = false
    }
  },
  watch:{
    
  },
  async created(){
    await this.loadProducts()
    this.getWarehouses()
    this.loadVendors()
    this.LoadInvoices()
    this.getMoveOrders()
  }
}
</script>

<style>

</style>
